import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import "@/styles/global.css";

const renderStartupError = (error: unknown) => {
  const container = document.getElementById("root");
  if (!container) return;
  const message = error instanceof Error ? error.message : String(error);
  container.innerHTML = `<div style="min-height:100vh;padding:24px;font-family:system-ui,sans-serif;background:#f8fafc;color:#0f172a"><div style="max-width:720px;margin:0 auto;border:1px solid #fecaca;background:white;border-radius:12px;padding:24px"><h1 style="margin:0 0 8px;font-size:20px;color:#b91c1c">Failed to start LoginAlerts</h1><p style="margin:0;color:#475569">${message}</p></div></div>`;
};

import("../Root")
  .then(({ default: Root }) => {
    const container = document.getElementById("root");
    if (!container) throw new Error("Root container #root not found");
    createRoot(container).render(
      <StrictMode>
        <Root />
      </StrictMode>
    );
  })
  .catch(renderStartupError);
